import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';
import { useParams } from 'react-router-dom';

const TaxTypeInput = () => {
  const { taxTypeId = '' } = useParams();
  const decodedId = taxTypeId ? atob(taxTypeId) : taxTypeId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'tax_type';

  useEffect(() => {
    if (taxTypeId) {
      setIsEditing(true);
      fetchTaxTypeDetails();
    }
  }, [taxTypeId]);

  const fetchTaxTypeDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.tax_type}${id}/`, { headers });
      const taxTypeDetails = response.data;

      setFormData(taxTypeDetails);
    } catch (error) {
      console.error('Error fetching tax type details:', error);
    }
  };

  const handleFormSubmitSuccess = (response) => {
    
  };

  const taxTypeFields = [
    {
      name: 'name',
      label: 'Name',
      type: 'text',
    },
    {
      name: 'code',
      label: 'Code',
      type: 'text',
    },
    {
      name: 'category',
      label: 'Category',
      type: 'select',
      options: [
        { value: 'SALES', label: 'Sales Tax' },
        { value: 'PURCHASE', label: 'Purchase Tax' },
        { value: 'PAYROLL', label: 'Payroll Tax' },
        { value: 'OTHER', label: 'Other' },
      ],
    },
    {
      name: 'rate',
      label: 'Rate(Percentage)',
      type: 'number',
    },
    {
      name: 'description',
      label: 'Description',
      type: 'textarea',
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Tax Type' : 'Create Tax Type'}</h1>
      <FormComponent
        fields={taxTypeFields}
        initialFormData={formData}
        route={route}
        onSubmitSuccess={handleFormSubmitSuccess}
        onSubmitError={() => {}}
      />
    </div>
  );
};

export default TaxTypeInput;